/* istanbul ignore file */
import { FormSection, FormRow, MediumFormRow, BigFormRow } from 'framework/ui/layout';
import { AddressInput, TextInput, PhoneInput, TextArea, EmailListInput } from 'framework/form';
import { AccountNameInput } from 'domain/shared/account';
import { CrmAttachmentUploaderInput } from 'domain/shared/artifact/input';

const ContactForm = () => {
  return (
    <>
      <FormSection title="Contact information">
        <FormRow>
          <TextInput source="firstName" label="First name" />
          <TextInput source="middleName" label="Middle name" />
          <TextInput source="lastName" label="Last name" />
          <AccountNameInput label="Account name" source="accountId" />
        </FormRow>

        <FormRow>
          <PhoneInput label="Phone 1" source="phoneNumber" hasExtension />
          <PhoneInput label="Phone 2" source="mobilePhoneNumber" />
          <TextInput label="LinkedIn" source="linkedInLink" />
          <TextInput source="title" />
        </FormRow>

        <FormRow>
          <EmailListInput label="Email" source="emails" />
        </FormRow>
      </FormSection>

      <FormSection title="Address information">
        <AddressInput source="address" addressLine1Label="Street" zipLabel="Zip/Postal code" />
      </FormSection>

      <FormSection title="Description">
        <MediumFormRow>
          <TextArea label="Original lead description" source="description" />
        </MediumFormRow>
        <BigFormRow>
          <CrmAttachmentUploaderInput label="Attachments" source="attachmentsIds" />
        </BigFormRow>
      </FormSection>
    </>
  );
};

export default ContactForm;
